var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_4551)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32.5C24.8366 32.5 32 25.3366 32 16.5C32 7.66344 24.8366 0.5 16 0.5C7.16344 0.5 0 7.66344 0 16.5C0 25.3366 7.16344 32.5 16 32.5Z",
    fill: "#374151"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6719 23.8722V14.1128H8.65556V23.8722H11.6719ZM11.6719 10.6536C11.654 9.7802 11.0719 9.11523 10.1263 9.11523C9.1805 9.11523 8.5625 9.7802 8.5625 10.6536C8.5625 11.508 9.16253 12.1922 10.0901 12.1922H10.1081C11.0719 12.1922 11.6719 11.508 11.6719 10.6536ZM16.593 23.8722V18.3118C16.593 18.0142 16.6145 17.7166 16.702 17.5045C16.9412 16.9096 17.4857 16.2938 18.4 16.2938C19.5977 16.2938 20.3488 16.9735 20.3488 18.3118V23.8722H23.3856V18.163C23.3856 15.1046 21.753 13.6815 19.5753 13.6815C17.7898 13.6815 17.0061 14.6798 16.5709 15.3592L16.5927 14.0539H13.5612C13.6048 14.9882 13.5612 23.8722 13.5612 23.8722H16.593Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_4551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0ac3053bdf6cae1ca119d106dadb84e4.svg";
export { ForwardRef as ReactComponent };